export default __webpack_public_path__ + "static/dso-vertical-c8fbe57bfbe922de18b345ea891f718e.png";